import { render, staticRenderFns } from "./PersonalInfoView.vue?vue&type=template&id=367dfcc3"
import script from "./PersonalInfoView.ts?vue&type=script&lang=ts&external"
export * from "./PersonalInfoView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports